import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXL } from '@sorare/core/src/atoms/typography';
import { FrameCorners } from '@sorare/core/src/atoms/ui/FrameCorners';
import { fantasy } from '@sorare/core/src/lib/glossary';

import replayIcon from './assets/replayIcon.webp';

const Img = styled.img`
  width: var(--triple-unit);
  height: var(--triple-unit);
  object-fit: contain;
`;

export const ReplayTitle = () => {
  return (
    <div className="relative px-2 py-1">
      <FrameCorners cornerSize={8} color="var(--c-rewards-yellow)" />
      <Horizontal>
        <Img src={replayIcon} alt="" />
        <BrandXL as="span" color="var(--c-rewards-yellow)">
          <FormattedMessage {...fantasy.training} />
        </BrandXL>
      </Horizontal>
    </div>
  );
};
